import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunKindsFetchFailedAction = {
	type: 'WORKFLOW_RUN_KINDS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunKindsFetchFailedAction => ({
	type: 'WORKFLOW_RUN_KINDS_FETCH_FAILED',
	payload,
});
